var map = {
	"./BlogTemplate": [
		916745,
		86373,
		71352,
		43939,
		68294,
		61395
	],
	"./BlogTemplate.tsx": [
		916745,
		86373,
		71352,
		43939,
		68294,
		61395
	],
	"./WorkTemplate": [
		382021,
		71791,
		86373,
		71352,
		43939,
		88721,
		68294,
		4701,
		61134
	],
	"./WorkTemplate.tsx": [
		382021,
		71791,
		86373,
		71352,
		43939,
		88721,
		68294,
		4701,
		61134
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 452644;
module.exports = webpackAsyncContext;